import Failed from './Failed';
export type { FailedProps } from './Failed.types';
export default Failed;
